"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var checkStatus = function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);
  error.code = -101;
  throw error;
};

var parseJSON = function parseJSON(response) {
  return response.json();
};

function _default(url, options) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6000;
  var abortTimer;
  var abortPromise = new Promise(function (resolve, reject) {
    abortTimer = setTimeout(function () {
      var error = new Error('请求超时');
      error.code = -102;
      reject(error);
    }, timeout);
  });
  var fetchPromise = (0, _isomorphicFetch["default"])(url, _objectSpread({
    mode: 'cors',
    credentials: 'include'
  }, options));
  var allPromise = Promise.race([fetchPromise, abortPromise]);
  return allPromise.then(function (result) {
    clearTimeout(abortTimer);
    return result;
  }).then(checkStatus).then(parseJSON)["catch"](function (e) {
    clearTimeout(abortTimer);
    return {
      code: e.code || -1,
      error: e.message || e.toString()
    };
  });
}